import { prepareOption } from '../../services/utils';

export const BASE_URL = 'firms';

export const FIRM_TYPE_FILTER_KEY = 'firm-type';
export const FIRM_NAME_FILTER_KEY = 'firm-name';
export const PROJECT_TYPE_FILTER_KEY = 'project-type';
export const PROJECT_LOCATION_FILTER_KEY = 'project-location';
export const FIRM_LOCATION_FILTER_KEY = 'firm-location';

export const DEFAULT_FIRM_TYPE = prepareOption(
  'Architecture / Design Firms',
  'Architecture / Design Firm',
  { type: FIRM_TYPE_FILTER_KEY },
);
export const ALL_FIRM_NAMES = prepareOption('All Firm Names');
export const ALL_PROJECT_TYPES = prepareOption('All Project Types');
export const ALL_PROJECT_LOCATIONS = prepareOption('All Project Locations');
export const ALL_FIRM_LOCATIONS = prepareOption('All Firm Locations');

export const SORTINGS = [
  prepareOption('Recently Featured', 'recently-featured'), // <== default
  prepareOption('Recommended', 'recommended'),
  prepareOption('Built Projects', 'built-projects'),
  prepareOption('Recently Built', 'recently-built'),
  prepareOption('A-Z', 'alphabetical'), // <== only available for affiliation directories
];

export const DEFAULT_FILLTERS_VALUES = [
  SORTINGS[0].value,
  ALL_FIRM_NAMES.value,
  DEFAULT_FIRM_TYPE.value,
  ALL_PROJECT_TYPES.value,
  ALL_PROJECT_LOCATIONS.value,
  ALL_FIRM_LOCATIONS.value,
];

export const OPERATION = {
  LOAD_MORE: 'LOAD_MORE',
  LOAD_NEW: 'LOAD_NEW',
};

export const filtersMap = {
  sort: 'selectedSort',
  [FIRM_TYPE_FILTER_KEY]: 'selectedFirmType',
  [FIRM_NAME_FILTER_KEY]: 'selectedFirmName',
  [PROJECT_TYPE_FILTER_KEY]: 'selectedProjectType',
  [PROJECT_LOCATION_FILTER_KEY]: 'selectedProjectLocation',
  [FIRM_LOCATION_FILTER_KEY]: 'selectedFirmLocation',
};

export const emptyFilterMessage = 'No related results';

export const ANALYTICS_NAME = {
  SEARCH_SUBMITTED: 'firm search - search submitted',
  RESULT_CLICKED: 'firm search - result clicked',
};

export const ANALYTICS_TYPE = {
  FIRM_PROFILE: 'firm profile',
  PROJECT_CARD: 'project card',
  CONTACT: 'contact',
  IMAGE_SEARCH: 'image search',
};

export const FIRM_TYPE_PLURALIZATION = {
  ignore: [],
  convert: {
    Development: 'Developer',
  },
};
